import { defineStore } from 'pinia'
import { ref } from 'vue'
import type { Ref } from 'vue'
import localStorage from '@/services/storage/localStorage'

const PAGINATION_STATE = 'pagination'

interface Pagination {
  offset: number
  limit: number
}

const defaultPagination = (): Pagination => ({
  offset: 0,
  limit: 20
})

const getPaginationState = (): Pagination =>
  localStorage.get(PAGINATION_STATE, true) || defaultPagination()

export const usePaginationStore = defineStore('pagination', () => {
  const pagination: Ref<Pagination> = ref(getPaginationState())

  // getters
  const getOffset = (): number => pagination.value.offset
  const getLimit = (): number => pagination.value.limit

  // actions
  const updateOffset = (offset: number): void => {
    pagination.value.offset = offset
    localStorage.set(PAGINATION_STATE, pagination.value, true)
  }

  const updateLimit = (limit: number): void => {
    pagination.value.limit = limit
    localStorage.set(PAGINATION_STATE, pagination.value, true)
  }

  const clearPagination = (): void => {
    localStorage.delete(PAGINATION_STATE)
    pagination.value = defaultPagination()
  }

  return {
    pagination,
    getOffset,
    getLimit,
    updateOffset,
    updateLimit,
    clearPagination
  }
})
